import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { IBonoRendimientoCombustible } from '../models/bonorendimientocombustible';

@Injectable({
  providedIn: 'root'
})
export class BonoRendimientoservice{
  private apiUrl: string ='';
  constructor(private _http: HttpClient) {
    this.apiUrl = environment.sUrlNomina + 'BonoRendimientoCombustible';
  }


  // private apiUrl: string = environment.sUrlNomina + 'BonoRendimientoCombustible';



 getbono(month: number,year:number,city:number ,conf: number): Observable<IBonoRendimientoCombustible[]> {
  const valores = {
    params: new HttpParams().
       set('num_mes',month).
       set('num_anio',year).
       set('id_ciudad',city).
       set('clave_confUnidad',conf)

  }
  return this._http
      .get<IBonoRendimientoCombustible[]>(this.apiUrl,valores)
      .pipe(retry(1), catchError(this.handleError));

 }


public postbonoRendimientoIndividual(data: any):Observable<any>{
  const headers = { 'content-type': 'application/json'}
  const body = JSON.stringify(data);
  return this._http.post<any>(this.apiUrl + '/bonoindirendimiento/',body,{'headers':headers});
 }

 public postbonoRendimientoMasivo(data: any):Observable<any>{
  const headers = { 'content-type': 'application/json'}
  const body = JSON.stringify(data);
  return this._http.post<any>(this.apiUrl + '/bonoindirendimientomasivo/',body,{'headers':headers});
 }
 public eliminarbono(data: any):Observable<any>{
  const headers = { 'content-type': 'application/json'}
  const body = JSON.stringify(data);
  return this._http.post<any>(this.apiUrl + '/eliminarbono/',body,{'headers':headers});
 }

 rptbono(selectMonth: number, selectYear: number,selectCity : number, selectConf:number): Observable<any[]> {
  const valores = {
    params: new HttpParams()
      .set('num_mes', selectMonth)
      .set('num_anio', selectYear)
      .set('id_ciudad', selectCity )
      .set('clave_confUnidad', selectConf )

  }
  return this._http
      .get<any[]>(this.apiUrl+'/rptbonorendimiento',valores).pipe(retry(1), catchError(this.handleError));

 }

//  public deletebonodesepeno(data: any):Observable<any>{
//   const headers = { 'content-type': 'application/json'}
//   const body = JSON.stringify(data);
//   return this.http.post<any>(this.apiUrl + '/deletebonodesem/',body,{'headers':headers});
//  }


//  getrptbonodesepeno(num_anio: number,num_mes_rpt:number ,id_ciudad_hm: number): Observable<any[]> {
//   const valores = {
//     params: new HttpParams().
//        set('num_anio',num_anio).
//        set('num_mes_rpt',num_mes_rpt).
//        set('id_ciudad_hm',id_ciudad_hm)

//   }
//   return this.http
//       .get<any[]>(this.apiUrl +'/rptbonodesem',valores)
//       .pipe(retry(1), catchError(this.handleError));

//  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

}
